<template>
  <div
    v-if="isEditMode"
    class="fi-col-span-12 fi-text-center"
  >
    Please manage list items in the component's settings
  </div>
  <grid-columns-fi
    v-for="podcast in list"
    :key="podcast.fields?.episode?.value"
    :columns="10"
    grid-base-class="fi-gap-zero"
    class="podcasts-list-fi__episode"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="isEditMode"
      class="podcasts-list-fi__episode-image"
      v-html="podcast.fields?.image?.editable"
    />
    <!-- eslint-enable vue/no-v-html -->
    <div
      v-else
      class="podcasts-list-fi__episode-image-wrapper"
    >
      <cloud-image-fi
        class="podcasts-list-fi__episode-image"
        params="func=crop&aspect_ratio=11:10"
        :field="podcast.fields?.image"
        full-height
      />
    </div>
    <div class="podcasts-list-fi__episode-details">
      <!-- eslint-disable vue/no-v-html -->
      <h4
        v-if="isEditMode"
        class="podcasts-list-fi__episode-nr"
        v-html="podcast.fields?.nr?.editable"
      />
      <!-- eslint-enable vue/no-v-html -->
      <h4
        v-else
        class="podcasts-list-fi__episode-nr"
      >
        {{ $dict.get('podcasts.Episode-Number', [podcast.fields?.nr?.value]) }}
      </h4>
      <headline-fi
        class="podcasts-list-fi__episode-headline"
        tag="h3"
        :size="36"
        :field="podcast.fields?.headline"
      />
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-if="isEditMode"
        class="podcasts-list-fi__episode-description"
        v-html="podcast.fields?.description?.editable"
      />
      <!-- eslint-enable vue/no-v-html -->
      <div
        v-else
        class="podcasts-list-fi__episode-description"
      >
        {{ podcast.fields?.description?.value }}
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-if="isEditMode"
        v-html="podcast.fields?.episode?.editable"
      />
      <!-- eslint-enable vue/no-v-html -->
      <div
        v-for="(episode, idx) in podcast.fields?.episode?.value?.split(',') || []"
        :key="idx"
        :ref="(ref) => (players[episode] = ref)"
        class="podcasts-list-fi__episode-player"
      />
    </div>
  </grid-columns-fi>
</template>

<script>
import { CloudImageFi, HeadlineFi } from 'atoms';

import GridColumnsFi from '@/components/grid-fi/GridColumnsFi.vue';

export default {
  name: 'PodcastsListFi',
  components: {
    CloudImageFi,
    GridColumnsFi,
    HeadlineFi,
  },
  inject: ['fields'],
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      players: {},
    };
  },
  computed: {
    configuration() {
      if (!this.fields.configuration || !this.fields.configuration.value) {
        console.error('podcasts-fi is missing configuration');
        return null;
      }
      return this.fields.configuration.value.trim();
    },
  },
  mounted() {
    if (IS_SSR || this.isEditMode) {
      return;
    }
    this.list.forEach(({ fields: { episode } }) => {
      episode?.value?.split(',').forEach((singleEpisodeRaw) => {
        const singleEpisode = singleEpisodeRaw
          .trim()
          .replace(/.*\//, '')
          .replace(/[#?].*/, '');
        const player = this.players[singleEpisodeRaw];
        if (!player) {
          console.error('player ref not found for podcast', singleEpisode);
          return;
        }
        if (player.querySelector('podigee-podcast-player')) {
          return;
        }
        const script = document.createElement('script');
        script.classList.add('podigee-podcast-player');
        script.src =
          'https://player.podigee-cdn.net/podcast-player/javascripts/podigee-podcast-player.js';
        script.dataset.configuration = this.configuration.replace('{0}', singleEpisode);
        player.appendChild(script);
      });
    });
  },
};
</script>

<style scoped src="./podcasts-list-fi" />
